import { lazy } from 'react';

import { ALLOWED_ROLES } from 'packages/utils';

import { PATHS } from './constants';
import { ActiveSchedulesDashboardProvider } from './screens/ActiveSchedulesDashboard/context';
import ActiveUserDashboard from './screens/ActiveUserDashboard';
import CheckpointRoutesDashboard from './screens/CheckpointRoutesDashboard';
import { CheckpointRoutesDashboardProvider } from './screens/CheckpointRoutesDashboard/context/CheckpointRoutesDashboardContext';
import EventsDashboard from './screens/EventsDashboard';
import SchedulesDashboard from './screens/SchedulesDashboard';
import { ScheduleDashboardProvider } from './screens/SchedulesDashboard/context/ScheduleDashboardContext';
import TasksDashboard from './screens/TasksDashboard';
import { TasksDashboardProvider } from './screens/TasksDashboard/context/TasksDashboardContext';

const ActiveSchedulesDashboard = lazy(() => import('./screens/ActiveSchedulesDashboard'));
const OperationReport = lazy(() => import('./screens/OperationReport'));
const ActiveCheckpointRoutesDashboard = lazy(
  () => import('./screens/ActiveCheckpointRoutesDashboard'),
);

const dashboardRoutes = [
  {
    component: OperationReport,
    path: PATHS.OPERATION_REPORT,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.REPORTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.OPERATION_REPORT}`,
  },
  {
    component: () => (
      <ScheduleDashboardProvider>
        <SchedulesDashboard />
      </ScheduleDashboardProvider>
    ),
    path: PATHS.SCHEDULES,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.REPORTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.SCHEDULES}`,
  },
  {
    component: () => (
      <CheckpointRoutesDashboardProvider>
        <CheckpointRoutesDashboard />
      </CheckpointRoutesDashboardProvider>
    ),
    path: PATHS.CHECKPOINT_ROUTES,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.REPORTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.CHECKPOINT_ROUTES}`,
  },
  {
    component: () => (
      <TasksDashboardProvider>
        <TasksDashboard />
      </TasksDashboardProvider>
    ),
    path: PATHS.TASKS,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.REPORTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.TASKS}`,
  },
  {
    component: TasksDashboard,
    path: PATHS.TASKS_TIMELINE_DRAWER,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.TASKS}`,
  },
  {
    component: CheckpointRoutesDashboard,
    path: PATHS.CHECKPOINT_ROUTES_TIMELINE_DRAWER,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.CHECKPOINT_ROUTES}`,
  },
  {
    component: () => (
      <ActiveSchedulesDashboardProvider>
        <ActiveSchedulesDashboard />
      </ActiveSchedulesDashboardProvider>
    ),
    path: PATHS.ACTIVE_SCHEDULES,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.EXECUTIONS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.ACTIVE_SCHEDULES}`,
  },
  {
    component: ActiveCheckpointRoutesDashboard,
    path: PATHS.ACTIVE_CHECKPOINT_ROUTES_DASHBOARD,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.EXECUTIONS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.ACTIVE_CHECKPOINT_ROUTES_DASHBOARD}`,
  },
  {
    component: props => <EventsDashboard {...props} />,
    path: PATHS.EVENTS,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DASHBOARDS.CHARTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.EVENTS}`,
  },
  {
    component: props => <EventsDashboard {...props} />,
    path: `${PATHS.EVENTS}/:boardId`,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DASHBOARDS.CHARTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.EVENTS}`,
  },
  {
    component: ActiveUserDashboard,
    path: PATHS.ACTIVE_USER_DASHBOARD,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.DASHBOARDS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.ACTIVE_USER_DASHBOARD}`,
  },
  {
    component: SchedulesDashboard,
    path: PATHS.TIMELINE_EVENT_DRAWER,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.SCHEDULES}`,
  },
];

export default dashboardRoutes;
